import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    Button,
    Box
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    competenciesTable: {
        border: '2px solid black',
        margin: '20px 0',
        width: '100%',
        overflowX:'unset !important',
    },
    tableHeader: {
        backgroundColor: 'black',
        color: '#ffffff !important',
        fontWeight: 'bold'
    },
    tableRow: {
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    },
    selectedRow: {
        backgroundColor: '#e8f5e9 !important'
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        marginTop: '20px'
    },
    noneButton: {
        marginTop: "20px !important",
        width: "200px",
        borderRadius:'20px !important',
        fontSize: "14px",
        textAlign: "center",
        textTransform: "none",
        backgroundColor: "#FE686F !important",
        color:'#ffffff 1important',
    },
    submitButton: {
            marginTop: "20px !important",
            width: "200px",
            borderRadius:'20px !important',
            fontSize: "14px",
            textAlign: "center",
            textTransform: "none",
            backgroundColor: "#FE686F !important",
            color:'#ffffff 1important',
    },
}));

const CompetencyTable = ({ onNoneSelected, onSubmit, selectedCompetencies, setSelectedCompetencies }) => {
    const classes = useStyles();

    const handleCompetencySelect = (competencyCode) => {
        setSelectedCompetencies(prev => {
            if (prev.includes(competencyCode)) {
                return prev.filter(code => code !== competencyCode);
            } else {
                return [...prev, competencyCode];
            }
        });
    };

    return (
        <>
            <TableContainer component={Paper} className={classes.competenciesTable}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeader}>DQ Code</TableCell>
                            <TableCell className={classes.tableHeader}>Competency Title</TableCell>
                            <TableCell className={classes.tableHeader}>Description</TableCell>
                            <TableCell className={classes.tableHeader}>Frameworks</TableCell>
                            <TableCell className={classes.tableHeader}>Select</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow className={`${classes.tableRow} ${selectedCompetencies.includes('DQ.AI.1') ? classes.selectedRow : ''}`}>
                            <TableCell>DQ.AI.1</TableCell>
                            <TableCell>Recognizing AI Application</TableCell>
                            <TableCell>Understand common uses of AI in daily life applications</TableCell>
                            <TableCell>IEEE, ISTE, UNESCO</TableCell>
                            <TableCell>
                                <Checkbox
                                    checked={selectedCompetencies.includes('DQ.AI.1')}
                                    onChange={() => handleCompetencySelect('DQ.AI.1')}
                                    color="primary"
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow className={`${classes.tableRow} ${selectedCompetencies.includes('DQ.ETH.3') ? classes.selectedRow : ''}`}>
                            <TableCell>DQ.ETH.3</TableCell>
                            <TableCell>Ethical Use of AI Tools</TableCell>
                            <TableCell>Evaluate fairness, bias, and privacy concerns</TableCell>
                            <TableCell>IEEE, ISTE, UNESCO</TableCell>
                            <TableCell>
                                <Checkbox
                                    checked={selectedCompetencies.includes('DQ.ETH.3')}
                                    onChange={() => handleCompetencySelect('DQ.ETH.3')}
                                    color="primary"
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Box className={classes.actionButtons}>
                <Button
                    variant="contained"
                    className={classes.noneButton}
                    onClick={onNoneSelected}
                >
                    None of the above
                </Button>
                <Button
                    variant="contained"
                    className={classes.submitButton}
                    onClick={() => onSubmit(selectedCompetencies)}
                    disabled={selectedCompetencies.length === 0}
                >
                    Submit
                </Button>
            </Box>
        </>
    );
};

export default CompetencyTable;